import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { useAuth } from './hooks/useAuth'
import AppShell from './components/layout/AppShell'
import LoadingScreen from './components/common/LoadingScreen'
import LoginPage from './pages/LoginPage'
import SsoRoute from './features/sso/SsoRoute'

const DashboardPage = lazy(() => import('./pages/DashboardPage'))
const ReportEditorPage = lazy(() => import('./pages/ReportEditorPage'))
const ResourcesPage = lazy(() => import('./pages/ResourcesPage'))
const NestedResourcesPage = lazy(() => import('./pages/NestedResourcesPage'))
const FileManagementPage = lazy(() => import('./pages/FileManagementPage'))
const DataExportPage = lazy(() => import('./pages/DataExportPage'))

function ProtectedApp() {
  const location = useLocation()
  const { user, loading } = useAuth()
  if (location.pathname === '/sso/start') {
    return <SsoRoute mode="start" />
  }
  if (location.pathname === '/sso') {
    return <SsoRoute mode="callback" />
  }
  if (loading) return <LoadingScreen label="Memverifikasi akses..." />
  if (!user) return <LoginPage />

  return (
    <AppShell>
      <Suspense fallback={<LoadingScreen label="Membuka halaman..." compact />}>
        <Routes>
          <Route path="/" element={<Navigate to="/forms" replace />} />
          <Route path="/forms" element={<DashboardPage />} />
          <Route path="/forms/:formId" element={<ReportEditorPage />} />
          <Route path="/reports/:reportId" element={<ReportEditorPage />} />
          <Route path="/files/:folderId?" element={<FileManagementPage />} />
          <Route path="/export-data" element={<DataExportPage />} />
          <Route
            path="/resources"
            element={<Navigate to="/resources/brands" replace />}
          />
          <Route
            path="/resources/brands/:brandId/contacts/:nestedId?"
            element={<NestedResourcesPage mode="brandContacts" />}
          />
          <Route
            path="/resources/brands/:brandId/printers/:nestedId?"
            element={<NestedResourcesPage mode="brandPrinters" />}
          />
          <Route
            path="/resources/companies/:companyId/brands/:nestedId?"
            element={<NestedResourcesPage mode="companyBrands" />}
          />
          <Route
            path="/resources/companies/:companyId/contacts/:nestedId?"
            element={<NestedResourcesPage mode="companyContacts" />}
          />
          <Route
            path="/resources/companies/:companyId/print-specs/:nestedId?"
            element={<NestedResourcesPage mode="companyPrintSpecs" />}
          />
          <Route
            path="/resources/:section/:resourceId?"
            element={<ResourcesPage />}
          />
          <Route path="*" element={<Navigate to="/forms" replace />} />
        </Routes>
      </Suspense>
    </AppShell>
  )
}

export default function App() {
  return <ProtectedApp />
}
